import React, { useState } from 'react';
import Modal from '@pattern-library/modal';
import PropTypes from 'prop-types';

function LoginFormFooter({
    buttonText,
    modalAriaLabel,
    modalCloseButtonText,
    modalContent,
    modalHeaderText
}) {
    const [isActive, setIsActive] = useState(false);

    return (
        <>
            <div className="asc-mt-4">
                <p className="asc-mb-0 text--center">
                    <button
                        className="asc-btn asc-btn--link ul-account-set-up-help-btn"
                        id="account-set-up-help-link"
                        data-qa="account-set-up-help-link"
                        onClick={() => setIsActive(true)}
                    >
                        {buttonText}
                    </button>
                </p>
            </div>
            <Modal
                ariaLabel={modalAriaLabel}
                closeModal={() => setIsActive(false)}
                footerButtonAlignment="right"
                footerCloseButtonClasses="asc-btn"
                footerCloseButtonText={modalCloseButtonText}
                headerText={modalHeaderText}
                id="account-set-up-help-modal"
                isActive={isActive}
            >
                <div dangerouslySetInnerHTML={{ __html: modalContent }} />
            </Modal>
        </>
    );
}

LoginFormFooter.propTypes = {
    buttonText: PropTypes.string.isRequired,
    modalAriaLabel: PropTypes.string.isRequired,
    modalCloseButtonText: PropTypes.string.isRequired,
    modalContent: PropTypes.string.isRequired,
    modalHeaderText: PropTypes.string.isRequired
};

export default LoginFormFooter;
